/* eslint-disable no-unused-vars */
import { red } from '@mui/material/colors'
import { createTheme, alpha, getContrastRatio } from '@mui/material/styles'

const violetBase = '#7F00FF'
const violetMain = alpha(violetBase, 0.7)

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#009bc1',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#E0C2FF',
      light: '#F5EBFF',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#47008F',
    },
    warning: {
      main: '#ff9022',
    },
    background: {
      default: '#f5f5f6',
    },
    text: {
      primary: '#404040',
    },
    ochre: {
      main: '#E3D026',
      light: '#E9DB5D',
      dark: '#A29415',
      contrastText: '#242105',
    },
    violet: {
      main: violetMain,
      light: alpha(violetBase, 0.5),
      dark: alpha(violetBase, 0.9),
      contrastText: getContrastRatio(violetMain, '#fff') > 4.5 ? '#fff' : '#111',
    },
  },
  typography: {
    fontFamily: [
      'Nunito Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    fontSize: 14,
    pageTitle: {
      fontSize: '2rem',
      fontWeight: 800
    },
    itemTitle: {
      fontSize: '1.5rem',
      fontWeight: 700
    },
    itemSubtitle: {
      fontSize: '1.25rem',
      fontWeight: 700
    },
    itemDataLabel: {
      fontSize: '1rem',
      fontWeight: 700
    }
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        fullWidth: true,
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
          subtitle1: 'h2',
          subtitle2: 'h2',
          body1: 'span',
          body2: 'span',
          pageTitle: 'h1',
          itemTitle: 'h2',
          itemDataLabel: 'h3'
        },
      },
    },
  },
})

export default theme
